<template>
  <component :is="props.tag">
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
const props = defineProps<{
  tag: "h1" | "h2" | "h3" | "h4" | "h5";
}>();
</script>

<style scoped lang="scss">
h1,
h2,
h3,
h4,
h5 {
  @apply font-bold text-grey-100 dark:text-white;
}

h1 {
  @apply text-5xl lg:text-7xl 2xl:text-9xl;
}

h2 {
  @apply text-4xl lg:text-5xl 2xl:text-7xl;
}

h3 {
  @apply text-3xl lg:text-4xl 2xl:text-5xl;
}

h4 {
  @apply text-2xl lg:text-3xl 2xl:text-4xl;
}

h5 {
  @apply text-xl lg:text-2xl;
}
</style>
